import { z } from 'zod';

export const LinkSupplierProductBodySchema = z.object({
  tenantProductId: z.uuid(),
  supplierSku: z.string().trim().max(100).nullable().optional(),
  costPriceCents: z.string().regex(/^\d+$/).nullable().optional(),
  currency: z.string().length(3).optional(),
  minOrderQuantity: z.string().nullable().optional(),
  leadTimeDays: z.number().int().min(0).nullable().optional(),
});

export type LinkSupplierProductBody = z.infer<typeof LinkSupplierProductBodySchema>;

export const LinkSupplierProductResponseSchema = z.object({
  tenantSupplierProductId: z.uuid(),
});

export type LinkSupplierProductResponse = z.infer<typeof LinkSupplierProductResponseSchema>;

export const UpdateSupplierProductBodySchema = z.object({
  supplierSku: z.string().trim().max(100).nullable().optional(),
  costPriceCents: z.string().regex(/^\d+$/).nullable().optional(),
  currency: z.string().length(3).optional(),
  minOrderQuantity: z.string().nullable().optional(),
  leadTimeDays: z.number().int().min(0).nullable().optional(),
});

export type UpdateSupplierProductBody = z.infer<typeof UpdateSupplierProductBodySchema>;

export const SupplierProductItemSchema = z.object({
  id: z.uuid(),
  tenantProductId: z.uuid(),
  supplierSku: z.string().nullable(),
  costPriceCents: z.string().nullable(),
  currency: z.string(),
  minOrderQuantity: z.string().nullable(),
  leadTimeDays: z.number().nullable(),
  lastPurchaseAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type SupplierProductItem = z.infer<typeof SupplierProductItemSchema>;

export const ListSupplierProductsResponseSchema = z.object({
  items: z.array(SupplierProductItemSchema),
});

export type ListSupplierProductsResponse = z.infer<typeof ListSupplierProductsResponseSchema>;

export const SupplierProductItemResponseSchema = SupplierProductItemSchema;

export type SupplierProductItemResponse = z.infer<typeof SupplierProductItemResponseSchema>;
